import { memo } from 'react'
import { Link } from 'react-router-dom'
import { useSectionPad } from 'components/layout/section'

interface DocProps {
    title?: string
    description?: string
    children?: React.ReactNode
    isLoading?: boolean
    onClick?: () => void
    className?: string
    image?: React.ReactNode
    direction?: 'vertical' | 'horizontal'
    to?: string
    icon?: React.ReactNode
    iconOnClick?: () => void
    isDeleted?: boolean
    rightColumn?: React.ReactNode
}

const Doc: React.FC<DocProps> = ({ title, description, to, children, isLoading = false, onClick, className, image, direction = 'vertical', icon, iconOnClick, isDeleted, rightColumn }) => {
    const padX = useSectionPad()
    const flushMobile = !padX && direction === 'horizontal'

    const inner = () => (
        <div className={`flex flex-col gap-y-2 ${rightColumn ? 'flex-1 min-w-0' : ''}`}>
            <header className="flex flex-col gap-y-2">
                {isLoading ?
                <>
                    <div className="h3_skeleton"></div>
                </> :
                <>
                    <h3 className="">{title}</h3>
                </>
                }
            </header>
            <main className="flex flex-col gap-y-2">
                {children}
            </main>
        </div>
    )

    const hoverClasses = !isLoading ? (isDeleted ? 'hover:bg-red-200 cursor-pointer' : 'hover:bg-gray-100 cursor-pointer') : ''
    const classes = `border-[1px] border-gray-200 p-2 ${flushMobile ? 'rounded-none lg:rounded-md max-lg:border-x-0' : 'rounded-md'} ${isDeleted ? 'bg-red-100' : 'bg-white'} ${isLoading ? 'animate-pulse' : ''} ${hoverClasses} transition-colors ${className}`

    const iconElement = icon ? <span onClick={iconOnClick} className='[&>*]:fill-red-500 cursor-pointer'>{icon}</span> : null
    const rightColumnElement = rightColumn ? <div className="shrink-0 ml-auto">{rightColumn}</div> : null
    const content = image ?
        <>{image}{inner()}{rightColumnElement}{iconElement}</> :
        <>{inner()}{rightColumnElement}{iconElement}</>

    const withImageClasses = image ? `flex ${direction === 'horizontal' ? 'flex-row items-center gap-4' : 'flex-col gap-4'}` : ``
    const withoutImageClasses = !image ? `flex flex-col` : ``

    const classesFinal = `${classes} ${image ? withImageClasses : withoutImageClasses}`

    if (to) {
        return (
            <Link to={to} className={classesFinal} onClick={onClick}>
                {content}
            </Link>
        )
    } else {
        return (
            <div className={classesFinal} onClick={onClick}>
                {content}
            </div>
        )
    }

}

export default memo(Doc);

